import { ButtonsContainer } from "./PartsTableStyles";
import Button from "../../common/Button";
import { ButtonTypes, ButtonVariants } from "../../common/Button/constants";
import React from "react";
import { useAppSelector } from "../../../utils/hooks/store";
import { useUpdateSearch } from "../../../utils/hooks/partSearch";

export default function FilterButtons() {
  const loading = useAppSelector((state) => state.componentSearch.loading);
  const pendingFilters = useAppSelector(
    (state) => state.componentSearch.pendingFilters,
  );
  const updateSearch = useUpdateSearch();

  return (
    <ButtonsContainer>
      <Button
        label={"Apply filters"}
        type={ButtonTypes.BUTTON}
        onClick={() =>
          updateSearch({
            updateSearchParameters: { filters: pendingFilters, page: 1 },
          })
        }
      />
      <Button
        label={"Clear filters"}
        onClick={() =>
          updateSearch({
            updateSearchParameters: {
              filters: {},
              categoryIds: [],
              page: 1,
            },
          })
        }
        disabled={loading}
        type={ButtonTypes.BUTTON}
        variant={ButtonVariants.SECONDARY}
      />
    </ButtonsContainer>
  );
}
